export default "__VITE_ASSET__Bvjb6V1Z__"